import { ListStyle, Pointer } from '@yleisradio/areena-types';
import { Card } from 'components/Card';
import { useCards } from 'hooks/useCards';
import { useProgress } from 'hooks/useProgress';
import React from 'react';
import { getCardKey, getHistoryElapsedForCard } from 'utils/card';
import { GroupEngagementData } from 'components/SnowplowEngagementAnalytics/types';
import { PlaceholderCard } from 'components/PlaceholderCard';

type Props = {
  cardImageSizes: string;
  groupEngagementData: GroupEngagementData;
  hidden?: boolean;
  listStyle: ListStyle | undefined;
  pageIndex: number;
  pageKey: string;
  pageSize: number;
  source: Pointer;
  totalCount: number;
  searchQuery?: string | undefined;
  searchIdentifier?: string | undefined;
};

export const CardPage: React.FunctionComponent<Props> = ({
  cardImageSizes,
  groupEngagementData,
  hidden,
  listStyle,
  pageIndex,
  pageKey,
  pageSize,
  source,
  totalCount,
  searchQuery,
  searchIdentifier,
}) => {
  const { cards, loading } = useCards({
    source,
    pageIndex,
    pageSize,
  });

  const { historyEntries } = useProgress(cards);

  return (
    <>
      {cards.map((card, index) => {
        const totalIndex = pageIndex * pageSize + index;
        const cardKey = getCardKey(card, totalIndex, pageKey);

        return (
          <li
            key={cardKey}
            aria-posinset={totalIndex + 1}
            aria-setsize={totalCount}
            hidden={hidden}
          >
            <Card
              card={card}
              cardKey={cardKey}
              groupEngagementData={groupEngagementData}
              index={totalIndex}
              listStyle={listStyle}
              sizes={cardImageSizes}
              historyElapsed={getHistoryElapsedForCard(card, historyEntries)}
              searchQuery={searchQuery}
              searchIdentifier={searchIdentifier}
            />
          </li>
        );
      })}

      {loading &&
        Array.from({ length: pageSize }, (_, i) => (
          <li key={i} aria-hidden hidden={hidden}>
            <PlaceholderCard listStyle={listStyle} />
          </li>
        ))}
    </>
  );
};
